module.exports = __webpack_public_path__ + "static/media/ico-phone.babfd6d6.svg";